import {
    get,
    post,
    execute
} from "../axios";

/**
 * 通用模块-获取服务省市接口
 * @param {} 
 * @return {Promise} 
 */
export const GetProList = data => execute('eshopapi/v1/Common/GetProvinceAndCityList', data)
/**
 * 通用模块-获取服务区域接口
 * @param {cityCode} 
 * @return {Promise} 
 */
export const GetDisList = data => execute('eshopapi/v1/Common/GetDistrictList', data)
/**
 * 通用模块-获取乡镇接口
 * @param {districtCode} 
 * @return {Promise} 
 */
export const GetTownList = data => execute('eshopapi/v1/Common/GetTownList', data)
/**
 * 通用模块-单独获取省列表
 * @param {} 
 * @return {Promise} 
 */
export const GetNewProvinceList = data => execute('eshopapi/v1/Common/GetProvinceList', data)